import countries from 'constants/countries';

export const getEmailByCountry = (country) => {
  return supportConfig.email[country];
};

export const getExternalSupportEmailAndNameByCountry = (country) => {
  return { Email: supportConfig.externalSupportEmail[country], Name: supportConfig.names[country] };
};

export const supportConfig = {
  sharepointUrl: 'https://jll2.sharepoint.com/teams/ProductBrief-NeedsAssessment',
  brokerToolsSharepointUrl: 'https://jll2.sharepoint.com/teams/JLLBrokerTools',
  emeaSharepointUrl: 'https://jll2.sharepoint.com/teams/EMEA-JLLT-Product-Support',
  apacSharepointUrl: 'https://jll2.sharepoint.com/sites/APAC-JLLT-Product-Support',
  specialistBookingUrl:
    'https://outlook.office365.com/owa/calendar/NeedsAssessmentSupportTeam@jll2.onmicrosoft.com/bookings/',
  email: {
    [countries.US]: 'JLLAero@am.jll.com',
    [countries.UK]: 'emea.jllt.productsupport@jll.com',
    [countries.FR]: 'emea.jllt.productsupport@jll.com',
    [countries.EU]: 'emea.jllt.productsupport@jll.com',
    [countries.DE]: 'emea.jllt.productsupport@jll.com',
  },
  externalSupportEmail: {
    [countries.US]: 'BrokerTools@jll.com',
    [countries.UK]: 'emea.jllt.productsupport@jll.com',
    [countries.FR]: 'emea.jllt.productsupport@jll.com',
    [countries.EU]: 'emea.jllt.productsupport@jll.com',
    [countries.DE]: 'emea.jllt.productsupport@jll.com',
  },
  names: {
    [countries.US]: 'JLL Aero',
    [countries.UK]: 'EMEA Product Support',
    [countries.FR]: 'EMEA Product Support',
    [countries.EU]: 'EMEA Product Support',
    [countries.DE]: 'EMEA Product Support',
  }
};
